import { ReactNode } from 'react';

/**
 * 弹层/明细正文分节容器：给「只读明细」提供与表单弹窗**同一套**分组语言。
 *
 * 为什么需要它：表单弹窗长期用 `wb-form-section-title` 分节，而只读抽屉/明细没有等价件，
 * 于是正文要么靠 `<Divider>` 硬切、要么完全不分节——同一段内容进弹窗与进抽屉是两种排版。
 * 本组件渲染 `.bcc-section-title`（与 `wb-form-section-title` 共用同一条 CSS 规则体，
 * 见 `styles/components.css`），因此表单侧的渐变 accent 竖条在此原样成立，不新造第二套视觉。
 *
 * 边界：
 * - 只管「标题 + 内容」的分节与间距，不提供卡片底/边框——弹层内套 Card 是卡中卡，禁止；
 * - 页面级分区仍用 `SectionCard` / `.bcc-card-accent-title`，本组件不替代它们；
 * - 相邻分节的间距由标题自身 `margin` 承担（首节不留上边距），children 原样透传，
 *   调用方不要再补 `<Divider>` 或自写标题类。
 */
export interface DetailSectionProps {
  /** 分节标题（短句；禁止把说明文案塞进来，说明走 `FieldTip` / `sub`） */
  title: ReactNode;
  /** 标题右侧灰色副标题（口径同 `wb-form-section-sub`） */
  sub?: ReactNode;
  /** 标题行最右侧插槽（如「共 N 条」「刷新时间」），自动右对齐 */
  extra?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export default function DetailSection({ title, sub, extra, className, children }: DetailSectionProps) {
  return (
    <section className={className ? `bcc-section ${className}` : 'bcc-section'}>
      <div className="bcc-section-title">
        {title}
        {sub != null && <span className="bcc-section-sub">{sub}</span>}
        {extra != null && <span className="bcc-section-extra">{extra}</span>}
      </div>
      {children}
    </section>
  );
}
